import { render, staticRenderFns } from "./PanelController.vue?vue&type=template&id=7d0afa22&"
import script from "./PanelController.vue?vue&type=script&lang=js&"
export * from "./PanelController.vue?vue&type=script&lang=js&"
import style0 from "./PanelController.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports